import React, { memo } from "react";
import { bucketizeBrands } from "shared/components/Header/helpers";
import { Category } from "./styles";

interface ICategoriesProps {
    data: any;
    updateFilteredBrands: (brands: any) => void;
    updateSelectedBrandId: (idx: number) => void;
    selectedBrandId: number;
    allBrandsCategory: any;
    showAllBrands: boolean;
}

function Categories({
    data,
    updateFilteredBrands,
    updateSelectedBrandId,
    selectedBrandId,
    allBrandsCategory,
    showAllBrands,
}: ICategoriesProps) {
    if (showAllBrands) {
        data = [allBrandsCategory, ...data];
    }
    return (
        <Category>
            {data
                .filter(child => child.isActive)
                .map((child, idx: number) => {
                    const onClick: React.MouseEventHandler = e => {
                        e.preventDefault();
                        updateFilteredBrands(bucketizeBrands(child.children));
                        updateSelectedBrandId(idx);
                    };

                    const isSelected = selectedBrandId === idx;

                    const classname = isSelected ? "ch-anc selectedBrand" : "ch-anc";

                    return (
                        <button className={classname} key={idx} onClick={onClick}>
                            {child.title}
                            {isSelected && <i className="icon-arrow icon" />}
                        </button>
                    );
                })}
        </Category>
    );
}

export default memo(Categories);
